import dayjs from 'dayjs';
import * as ru from 'dayjs/locale/ru';

export function getDayDateTime(initialDate: Date | string) {
  let dateFormatted = initialDate;
  if (typeof dateFormatted === 'string') {
    dateFormatted = new Date(dateFormatted);
  }
  dayjs.locale(ru);
  // Преобразование входной даты в момент времени с указанием часового пояса Asia/Yekaterinburg
  const formatted = dayjs(dateFormatted).format();

  const day = extractDayOfWeek(formatted);
  const date = extractDate(formatted);
  const time = extractTime(formatted);

  return {
    day,
    date,
    time
  };
}

// Функция для извлечения даты в формате "день месяц год"
export function extractDate(formatted: string): string {
  return dayjs(formatted).format('D MMMM YYYY');
}

// Функция для извлечения дня недели
export function extractDayOfWeek(formatted: string): string {
  const day = dayjs(formatted).format('dddd');
  return day.charAt(0).toUpperCase() + day.slice(1);
}

// Функция для извлечения времени в формате "часы:минуты"
export function extractTime(formatted: string): string {
  return dayjs(formatted).format('HH:mm');
}

export function formatDuration(seconds: number) {
  const start = dayjs('2000-01-01');
  const end = start.add(seconds, 'second');

  const years = end.diff(start, 'year');
  const afterYears = start.add(years, 'year');

  const months = end.diff(afterYears, 'month');
  const afterMonths = afterYears.add(months, 'month');

  const days = end.diff(afterMonths, 'day');
  const afterDays = afterMonths.add(days, 'day');

  const hours = end.diff(afterDays, 'hour');
  const afterHours = afterDays.add(hours, 'hour');

  const minutes = end.diff(afterHours, 'minute');

  const parts = [];
  if (years > 0) parts.push(`${years} ${getPlural(years, 'год', 'года', 'лет')}`);
  if (months > 0) parts.push(`${months} ${getPlural(months, 'месяц', 'месяца', 'месяцев')}`);
  if (days > 0) parts.push(`${days} ${getPlural(days, 'день', 'дня', 'дней')}`);
  if (hours > 0) parts.push(`${hours} ${getPlural(hours, 'час', 'часа', 'часов')}`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes} ${getPlural(minutes, 'минута', 'минуты', 'минут')}`);

  return parts.join(' ');
}

function getPlural(n: number, one: string, few: string, many: string) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}
